import React, { Component } from 'react';
import AnchorErrorTracking from '../../../../modules/AnchorErrorTracking';

// https://sentry.io/anchor-fm-inc/frontend/getting-started/javascript-react/
class AppEntryBoundary extends Component {
  componentDidCatch(error, errorInfo) {
    AnchorErrorTracking.captureException({
      error,
      extraInformation: errorInfo,
    });
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

export { AppEntryBoundary };
